import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { DataTableHeader } from "vuetify";

import { VignetteRoutes } from "@/types";
import { VignetteCommitteeMemberResponse } from "@/types/api/SwaggerOutput";
import { SnakeToCamelCaseNested } from "@/types/utils/CaseTypes";

interface Props {
  staffers: SnakeToCamelCaseNested<VignetteCommitteeMemberResponse[]>;
  hideFirstTitle?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StafferTable',
  props: {
    staffers: null,
    hideFirstTitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  staffers: SnakeToCamelCaseNested<VignetteCommitteeMemberResponse[]>;
  hideFirstTitle?: boolean;
};



// makes default for use of optional prop value is false
const hideFirstTitle = props.hideFirstTitle ?? false;

const staffers = props.staffers;

const search = ref("");
const headers: DataTableHeader[] = [
  {
    text: "Name",
    value: "preferredNameDisplay",
    sortable: true,
    filterable: true,
    align: "start",
  },
  {
    text: "Title",
    value: "positionSummary",
    sortable: true,
    filterable: true,
  },
];

return { __sfc: true,props, hideFirstTitle, staffers, search, headers, VignetteRoutes }
}

})